import { useState } from "react";
import {
    Tooltip,
    ClickAwayListener,
    Box,
    Typography,
    Divider,
} from "@mui/material";

const FoodInfoToolTip = ({ name, description, children, parentRef }) => {
    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const handleToggle = (e) => {
        e.stopPropagation();
        setOpen((prev) => !prev);
    };

    const tooltipContent = (
        <Box sx={{ p: 1, minWidth: 80, maxWidth: 160 }}>
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: "13px",
                    textTransform: "capitalize",
                    lineHeight: 1.3,
                }}
            >
                {name}
            </Typography>
            {description && (
                <>
                    <Divider sx={{ my: 0.5, borderColor: "grey.500" }} />
                    <Typography sx={{ fontSize: "12px", opacity: 0.85, lineHeight: 1.4 }}>
                        {description}
                    </Typography>
                </>
            )}
        </Box>
    );

    return (
        <ClickAwayListener onClickAway={handleClose}>
            <div>
                <Tooltip
                    title={tooltipContent}
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    disableFocusListener
                    disableTouchListener
                    placement="bottom"
                    arrow
                    slotProps={{
                        tooltip: {
                            sx: {
                                bgcolor: "#8b8b8b",
                                borderRadius: 2,
                                boxShadow: 3,
                                p: 0,
                            },
                        },
                        arrow: {
                            sx: {
                                color: "#8b8b8b",
                            },
                        },
                        popper: {
                            disablePortal: false,
                            modifiers: [
                                {
                                    name: "preventOverflow",
                                    enabled: true,
                                    options: {
                                        boundary:
                                            parentRef?.current ||
                                            "clippingParents",
                                        altAxis: true,
                                        padding: 8,
                                    },
                                },
                                {
                                    name: "flip",
                                    enabled: true,
                                    options: {
                                        boundary:
                                            parentRef?.current ||
                                            "clippingParents",
                                        fallbackPlacements: [
                                            "bottom",
                                            "top",
                                            "right",
                                            "left",
                                        ],
                                    },
                                },
                            ],
                        },
                    }}
                >
                    <Box
                        onClick={handleToggle}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleToggle(e);
                            }
                        }}
                        tabIndex={0}
                        role="button"
                        aria-label={`Allergen info: ${name}`}
                        sx={{ cursor: "pointer", display: "inline-flex" }}
                    >
                        {children}
                    </Box>
                </Tooltip>
            </div>
        </ClickAwayListener>
    );
};

export default FoodInfoToolTip;
